import { render, staticRenderFns } from "./TextLogoToggle.vue?vue&type=template&id=c5f8b802&"
import script from "./TextLogoToggle.vue?vue&type=script&lang=js&"
export * from "./TextLogoToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports